module.exports = __webpack_public_path__ + "static/media/pay-online-inactive.63e7984f.svg";